import { render, staticRenderFns } from "./MaterialsTab.vue?vue&type=template&id=b464f2ba&lang=pug&"
import script from "./MaterialsTab.vue?vue&type=script&lang=js&"
export * from "./MaterialsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports